import { downloadFile, mapPaginationParamsToServer, format } from "@/shared";

export const exportProducts = async (paginationParams) => {
    const fileName = `exported_products_${format(
        new Date(),
        "dd_MM_yyyy-HH_mm"
    )}`;

    await downloadFile("/product/export", fileName, {
        ...mapPaginationParamsToServer(paginationParams),
    });
};
